import Keycloak from "keycloak-js"

export const keycloakInstance = new Keycloak({
  url: "https://auth.smkt.pro",
  realm: "smkt",
  clientId: "hiring-web",
})
